const PROFILE_ID_KEY = "profileId"
const EMPTY_VALUES = ["", "undefined", "null"]

const isEmptyValue = (value: string) => EMPTY_VALUES.includes(value.trim())

export const getProfileId = (): string | null => {
  const value = localStorage.getItem(PROFILE_ID_KEY)
  if (value === null || isEmptyValue(value)) {
    return null
  }
  return value
}

export const storeProfileId = (value?: string | number | null): void => {
  if (value === undefined || value === null) {
    return
  }
  const normalized = String(value).trim()
  if (isEmptyValue(normalized)) {
    return
  }
  localStorage.setItem(PROFILE_ID_KEY, normalized)
}
